<div class="cbl--item__progress">
  <button
    class="cbl--item__progress-control left"
    (click)="moveSlide('left')"
    [disabled]="currentCaseIdx() === 0 || battle().status === 'running'"
  >
    <svg-icon
      class="w-full flex items-center justify-center"
      src="assets/icons/ui/arrow.svg"
    />
  </button>

  <div class="cbl--item__progress-cases">
    <div class="cbl--item__progress-wrapper" #casesWrapperRef>
      @for (caseItem of cases(); track $index;) {
      <div
        @fadeInAnimation
        class="cbl--item__case"
        (click)="handleOpenSkinsPopup(caseItem)"
        [ngpTooltipTrigger]="tooltip"
        [ngpTooltipTriggerHideDelay]="0"
        [class.isRunning]="battle().status === 'running'"
        [class.isInactive]="
          battle().status === 'running' && $index !== activeCaseIdx()
        "
      >
        <img
          class="cbl--item__case-image"
          [src]="caseItem.image"
          [alt]="caseItem.name + ' case'"
          loading="lazy"
        />
        @if (battle().status !== 'running' && (caseItem?.quantity ?? 0) > 1) {
        <div class="cbl--item__case-quantity">{{ caseItem?.quantity }}x</div>
        }
      </div>
      <ng-template #tooltip>
        <div ngpTooltip class="tooltip flex flex-col">
          {{ caseItem.name }}
          <div class="flex">
            <app-cost
              [gap]="4"
              [cost]="caseItem.price"
              [balanceType]="balance()"
            ></app-cost>
            @if (battle().status === 'finished') {
            <div
              class="flex items-center"
              style="color: var(--gray); transform: scale(0.85)"
            >
              (<app-cost
                [gap]="4"
                [cost]="caseItem.price * caseItem.quantity"
                [balanceType]="balance()"
              ></app-cost
              >)
            </div>
            }
          </div>
        </div>
      </ng-template>
      }
    </div>
    @if(battle().status === 'running') {
    <svg-icon
      @fadeInOutAnimation
      class="cbl--item__progress-indicator top"
      src="assets/icons/cases/roll-indicator.svg"
    />
    <svg-icon
      @fadeInOutAnimation
      class="cbl--item__progress-indicator bottom"
      src="assets/icons/cases/roll-indicator.svg"
    />
    }
  </div>
  @let isRightDirectionDisabled = currentCaseIdx() + 1 > cases().length -
  (settings().perView);
  <button
    class="cbl--item__progress-control right"
    (click)="moveSlide('right')"
    [disabled]="isRightDirectionDisabled || battle().status === 'running'"
  >
    <svg-icon
      class="w-full flex items-center justify-center"
      src="assets/icons/ui/arrow.svg"
    />
  </button>
</div>
